import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './i18n'
import './styles/scss/index.scss'
import App from './App'
import store from './store/stroe'
import ProtectedRoute from './routes/ProtectedRoute'
import AuthPage from './pages/Auth/AuthPage'
import { UserRole } from './types/generalType'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Provider store={store}>
    <Router>
      <Routes>
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[
                UserRole.AdMINISTRATOR,
                UserRole.AdminWatcher,
                UserRole.Accountant,
                UserRole.ADMIN,
                UserRole.PILGRIM,
                UserRole.PROVICEBROKER,
                UserRole.BROKER,
              ]}
            />
          }
        >
          <Route path='/*' element={<App />} />
        </Route>
        <Route path='/Auth' element={<AuthPage />} />
      </Routes>
    </Router>
    <ToastContainer />
  </Provider>,
)
